import React, { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';
import ReviewCard from './components/ReviewCard';
import GalleryGrid from './components/GalleryGrid';
import FilterBar from './components/FilterBar';
import StatsOverview from './components/StatsOverview';
import InstagramFeed from './components/InstagramFeed';
import SubmitReviewModal from './components/SubmitReviewModal';
import MediaMentions from './components/MediaMentions';

const GalleryReviews = () => {
  const [activeTab, setActiveTab] = useState('reviews');
  const [activeCategory, setActiveCategory] = useState('all');
  const [activeRating, setActiveRating] = useState('all');
  const [sortBy, setSortBy] = useState('recent');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const stats = {
    averageRating: 4.7,
    totalReviews: 471,
    foodQuality: 4.8,
    service: 4.7,
    atmosphere: 4.6,
    value: 4.5,
    ratingDistribution: [
    { stars: 5, count: 342, percentage: 73 },
    { stars: 4, count: 89, percentage: 19 },
    { stars: 3, count: 28, percentage: 6 },
    { stars: 2, count: 8, percentage: 2 },
    { stars: 1, count: 4, percentage: 1 }]

  };

  const categories = [
  { value: 'all', label: 'All Reviews', icon: 'Star', count: 471 },
  { value: 'pastries', label: 'Pastries', icon: 'Croissant', count: 156 },
  { value: 'bread', label: 'Bread', icon: 'Wheat', count: 98 },
  { value: 'cakes', label: 'Custom Cakes', icon: 'Cake', count: 87 },
  { value: 'catering', label: 'Catering', icon: 'ChefHat', count: 64 },
  { value: 'service', label: 'Service', icon: 'Users', count: 66 }];


  const reviews = [
  {
    id: 1,
    name: "Maria Rossi",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_196c7ea17-1763297750794.png",
    avatarAlt: "Professional headshot of Italian woman with dark curly hair wearing elegant burgundy blouse smiling warmly",
    rating: 5,
    date: "November 28, 2025",
    location: "Etobicoke",
    category: "Pastries",
    verified: true,
    comment: "Absolutely authentic Italian pastries! The cornetti remind me of my grandmother\'s bakery in Rome. The sfogliatelle are perfectly crispy with just the right amount of sweetness. The staff is incredibly warm and welcoming. This is now my Sunday morning ritual.",
    helpful: 24,
    images: [
    {
      url: "https://images.unsplash.com/photo-1664013756402-0ee07849a423",
      alt: "Golden flaky Italian cornetti pastries arranged on white ceramic plate with espresso cup in morning sunlight"
    },
    {
      url: "https://images.unsplash.com/photo-1657313937945-c7aa356b832b",
      alt: "Close-up of crispy sfogliatelle pastry showing delicate layered texture with powdered sugar dusting"
    }],

    response: "Grazie mille, Maria! Your words warm our hearts. We're honored to bring you memories of home. See you next Sunday! - The Montesanto Family"
  },
  {
    id: 2,
    name: "David Chen",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1cb933d20-1763293416126.png",
    avatarAlt: "Professional headshot of Asian man with short black hair wearing navy business suit and glasses",
    rating: 5,
    date: "November 25, 2025",
    location: "Toronto",
    category: "Custom Cakes",
    verified: true,
    comment: "Ordered a custom cake for my daughter's graduation. The design exceeded our expectations - beautiful Italian-inspired decorations with fresh flowers. But the taste was even better! Three layers of perfection. Everyone at the party asked where we got it.",
    helpful: 18,
    images: [
    {
      url: "https://images.unsplash.com/photo-1629576690719-60ac92a4a41b",
      alt: "Three-tier white celebration cake decorated with fresh roses and Italian-style piping on elegant display stand"
    }],

    response: "Congratulations to your daughter, David! We're thrilled the cake was part of such a special celebration. Thank you for trusting us with your important moment!"
  },
  {
    id: 3,
    name: "Sarah Thompson",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11424144b-1763294805033.png",
    avatarAlt: "Professional headshot of blonde woman with shoulder-length hair wearing cream colored sweater smiling brightly",
    rating: 5,
    date: "November 22, 2025",
    location: "Mississauga",
    category: "Catering",
    verified: true,
    comment: "Used Montesanto for our corporate event with 80 guests. The presentation was stunning, the variety was perfect, and everything stayed fresh throughout the event. Multiple colleagues asked for the bakery's contact. Professional service from start to finish.",
    helpful: 31,
    response: "Thank you for choosing us for your important event, Sarah! We're delighted everything went perfectly. Looking forward to serving your team again!"
  },
  {
    id: 4,
    name: "Giuseppe Bianchi",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1b3336ea3-1763293061080.png",
    avatarAlt: "Professional headshot of Italian man with salt and pepper hair wearing white chef coat in bakery setting",
    rating: 5,
    date: "November 20, 2025",
    location: "Etobicoke",
    category: "Bread",
    verified: true,
    comment: "As someone who grew up in Naples, I'm very particular about Italian bread. Montesanto's ciabatta and focaccia are the real deal - proper fermentation, perfect crust, authentic flavor. Finally found a bakery in Toronto that understands Italian bread-making traditions.",
    helpful: 42,
    images: [
    {
      url: "https://images.unsplash.com/photo-1597388778288-8ae51973e2a3",
      alt: "Rustic Italian ciabatta bread with golden crispy crust and airy interior texture on wooden cutting board"
    },
    {
      url: "https://images.unsplash.com/photo-1618570284864-60d19919c5d4",
      alt: "Fresh rosemary focaccia bread with olive oil glaze and sea salt crystals on parchment paper"
    }],

    response: "Giuseppe, your approval means the world to us! Keeping authentic Neapolitan traditions alive is our passion. Grazie for recognizing our dedication!"
  },
  {
    id: 5,
    name: "Emily Rodriguez",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1a36548bd-1763296665300.png",
    avatarAlt: "Professional headshot of Hispanic woman with long dark hair wearing red blouse with warm friendly smile",
    rating: 4,
    date: "November 18, 2025",
    location: "Toronto",
    category: "Pastries",
    verified: true,
    comment: "Love their cannoli and tiramisu! The espresso is excellent too. Only giving 4 stars because they sometimes run out of my favorites by afternoon. Would be great if they made more batches. Still my go-to bakery though!",
    helpful: 15,
    response: "Thank you for the feedback, Emily! We're working on better predicting demand for our popular items. Your favorites will be waiting for you soon!"
  },
  {
    id: 6,
    name: "Michael O\'Brien",
    avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1ebb03a41-1763292034510.png",
    avatarAlt: "Professional headshot of middle-aged man with graying hair wearing plaid shirt with genuine warm expression",
    rating: 5,
    date: "November 15, 2025",
    location: "Etobicoke",
    category: "Service",
    verified: true,
    comment: "Been coming here for 3 years. The consistency is remarkable - quality never drops. The staff remembers my order and always has a smile. It\'s like visiting family. This is what a neighborhood bakery should be.",
    helpful: 28,
    response: "Michael, you're part of our Montesanto family! Thank you for your loyalty and for being such a wonderful part of our community. See you soon!"
  }];


  const galleryImages = [
  {
    url: "https://images.unsplash.com/photo-1702742136658-d77fb0115b1a",
    alt: "Assortment of golden Italian cornetti pastries with chocolate and cream fillings displayed on rustic wooden board",
    title: "Fresh Morning Cornetti",
    description: "Baked daily at 5am",
    badge: "Signature"
  },
  {
    url: "https://images.unsplash.com/photo-1638795805563-dcc7f7fe528c",
    alt: "Traditional Italian sfogliatelle pastries with crispy layered shells dusted with powdered sugar on marble surface",
    title: "Sfogliatelle",
    description: "Traditional Neapolitan recipe"
  },
  {
    url: "https://images.unsplash.com/photo-1561702856-b4ec96854ed8",
    alt: "Elegant three-tier white wedding cake decorated with fresh roses and Italian buttercream piping",
    title: "Custom Wedding Cake",
    description: "Made to order",
    badge: "Custom"
  },
  {
    url: "https://images.unsplash.com/photo-1618570284864-60d19919c5d4",
    alt: "Freshly baked rosemary focaccia bread with olive oil glaze and coarse sea salt on wooden cutting board",
    title: "Rosemary Focaccia",
    description: "Herb-infused perfection"
  },
  {
    url: "https://images.unsplash.com/photo-1723597784457-4c4b304e6830",
    alt: "Classic Italian tiramisu dessert in glass dish showing layers of espresso-soaked ladyfingers and mascarpone cream",
    title: "Tiramisu",
    description: "Family recipe since 1985",
    badge: "Best Seller"
  },
  {
    url: "https://images.unsplash.com/photo-1600975814842-69bd3df9c798",
    alt: "Golden cannoli shells filled with sweet ricotta cream and chocolate chips on decorative Italian ceramic plate",
    title: "Sicilian Cannoli",
    description: "Filled fresh daily"
  },
  {
    url: "https://images.unsplash.com/photo-1721007810668-30d8f8422912",
    alt: "Rustic Italian ciabatta bread loaves with crispy golden crust and open crumb structure on linen cloth",
    title: "Artisan Ciabatta",
    description: "24-hour fermentation"
  },
  {
    url: "https://images.unsplash.com/photo-1701351348533-ceeee1446329",
    alt: "Colorful Italian gelato display with multiple flavors including pistachio, stracciatella, and hazelnut in metal containers",
    title: "Artisan Gelato",
    description: "Made in-house daily",
    badge: "New"
  },
  {
    url: "https://images.unsplash.com/photo-1622494771716-ec967eac3d85",
    alt: "Elegant birthday cake with Italian buttercream frosting and fresh berry decoration on crystal cake stand",
    title: "Birthday Celebration",
    description: "Custom design available"
  },
  {
    url: "https://images.unsplash.com/photo-1605949790413-068f4b35ba52",
    alt: "Traditional Italian panettone bread with candied fruits and raisins in decorative paper wrapper",
    title: "Panettone",
    description: "Seasonal specialty"
  },
  {
    url: "https://images.unsplash.com/photo-1518963082292-ea2792afec49",
    alt: "Fresh Italian sandwiches on ciabatta bread with prosciutto, mozzarella, and arugula on wooden serving board",
    title: "Gourmet Sandwiches",
    description: "Made to order"
  },
  {
    url: "https://images.unsplash.com/photo-1701710807297-a13bc90810c4",
    alt: "Catering spread of Italian pastries and breads arranged on elegant white serving platters for corporate event",
    title: "Catering Display",
    description: "Perfect for events",
    badge: "Catering"
  }];


  const instagramPosts = [
  {
    image: "https://images.unsplash.com/photo-1600930496627-33491158a923",
    imageAlt: "Fresh morning cornetti pastries with golden flaky layers arranged artistically on white ceramic plate",
    likes: 342,
    comments: 28,
    link: "https://instagram.com/p/example1"
  },
  {
    image: "https://images.unsplash.com/photo-1696919462244-5db0d1b1ddd8",
    imageAlt: "Behind the scenes baker hands shaping traditional Italian bread dough on flour-dusted marble counter",
    likes: 289,
    comments: 19,
    link: "https://instagram.com/p/example2"
  },
  {
    image: "https://images.unsplash.com/photo-1706188458145-f11cb33aa1a0",
    imageAlt: "Stunning three-tier custom wedding cake with white fondant and fresh flower decorations",
    likes: 456,
    comments: 42,
    link: "https://instagram.com/p/example3"
  },
  {
    image: "https://images.unsplash.com/photo-1618652948030-44e7028754d1",
    imageAlt: "Freshly baked focaccia bread with rosemary and olive oil glistening in natural morning light",
    likes: 312,
    comments: 24,
    link: "https://instagram.com/p/example4"
  },
  {
    image: "https://images.unsplash.com/photo-1723597784457-4c4b304e6830",
    imageAlt: "Classic Italian tiramisu dessert in elegant glass showing perfect layers of mascarpone and espresso",
    likes: 398,
    comments: 35,
    link: "https://instagram.com/p/example5"
  },
  {
    image: "https://images.unsplash.com/photo-1600975814842-69bd3df9c798",
    imageAlt: "Golden cannoli shells filled with sweet ricotta cream and chocolate chips on vintage Italian plate",
    likes: 421,
    comments: 38,
    link: "https://instagram.com/p/example6"
  }];


  const mediaMentions = [
  {
    publication: "Toronto Life",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1df14f65f-1764538640502.png",
    logoAlt: "Toronto Life magazine logo in red and white color scheme",
    date: "October 2025",
    excerpt: "Montesanto Bakery brings authentic Italian baking traditions to Etobicoke, earning praise from both Italian expats and local food enthusiasts for their commitment to quality and tradition.",
    quote: "The best Italian pastries west of the city center",
    link: "https://torontolife.com/example"
  },
  {
    publication: "BlogTO",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_15cd82ded-1764538641637.png",
    logoAlt: "BlogTO publication logo with Toronto skyline silhouette",
    date: "September 2025",
    excerpt: "This family-run bakery has become a neighborhood institution, with customers traveling from across the GTA for their signature cornetti and custom cakes.",
    quote: "A hidden gem that rivals any bakery in Little Italy",
    link: "https://blogto.com/example"
  },
  {
    publication: "Etobicoke Guardian",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_154514ec9-1764538642324.png",
    logoAlt: "Etobicoke Guardian newspaper logo in traditional serif font",
    date: "August 2025",
    excerpt: "Montesanto Bakery continues to strengthen community bonds through their involvement in local events and their commitment to supporting neighborhood initiatives.",
    quote: "More than a bakery - it\'s a community gathering place",
    link: "https://etobicokeguardian.com/example"
  },
  {
    publication: "NOW Toronto",
    logo: "https://img.rocket.new/generatedImages/rocket_gen_img_1a7a89661-1764538641559.png",
    logoAlt: "NOW Toronto alternative weekly publication logo in bold modern typography",
    date: "July 2025",
    excerpt: "The Montesanto family's dedication to authentic Italian baking methods sets them apart in Toronto's competitive bakery scene, with their 4.7-star rating reflecting consistent excellence.",
    quote: "Authenticity you can taste in every bite",
    link: "https://nowtoronto.com/example"
  }];


  const filteredReviews = reviews?.filter((review) => {
    if (activeCategory !== 'all' && review?.category?.toLowerCase() !== activeCategory) return false;
    if (activeRating !== 'all' && review?.rating < parseInt(activeRating)) return false;
    return true;
  });

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="pt-20">
        <section className="bg-gradient-to-br from-primary/10 via-accent/5 to-background py-16">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto text-center">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary/10 text-primary text-sm font-medium mb-6">
                <Icon name="Award" size={18} />
                <span>4.7 Stars • 471+ Reviews</span>
              </div>
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
                Gallery & Reviews
              </h1>
              <p className="text-lg text-muted-foreground mb-8 max-w-2xl mx-auto">
                Experience the warmth of our community through authentic customer stories, stunning creations, and the genuine connections that make Montesanto special
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button
                  variant="default"
                  iconName="Star"
                  iconPosition="left"
                  onClick={() => setIsModalOpen(true)}>

                  Write a Review
                </Button>
                <Button
                  variant="outline"
                  iconName="Instagram"
                  iconPosition="left">

                  Follow on Instagram
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="container-custom">
            <StatsOverview stats={stats} />

            <div className="flex justify-center mb-8">
              <div className="inline-flex bg-card rounded-lg p-1 shadow-warm">
                <button
                  onClick={() => setActiveTab('reviews')}
                  className={`px-6 py-3 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-2 ${
                  activeTab === 'reviews' ? 'bg-primary text-primary-foreground shadow-warm' : 'text-foreground hover:bg-muted'}`
                  }>

                  <Icon name="MessageSquare" size={18} />
                  <span>Customer Reviews</span>
                </button>
                <button
                  onClick={() => setActiveTab('gallery')}
                  className={`px-6 py-3 rounded-lg text-sm font-medium transition-all duration-300 flex items-center gap-2 ${
                  activeTab === 'gallery' ? 'bg-primary text-primary-foreground shadow-warm' : 'text-foreground hover:bg-muted'}`
                  }>

                  <Icon name="Images" size={18} />
                  <span>Photo Gallery</span>
                </button>
              </div>
            </div>

            {activeTab === 'reviews' ?
            <>
                <FilterBar
                activeCategory={activeCategory}
                setActiveCategory={setActiveCategory}
                activeRating={activeRating}
                setActiveRating={setActiveRating}
                sortBy={sortBy}
                setSortBy={setSortBy}
                categories={categories} />


                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-12">
                  {filteredReviews?.map((review) =>
                <ReviewCard key={review?.id} review={review} />
                )}
                </div>

                <div className="text-center">
                  <Button variant="outline" iconName="ChevronDown" iconPosition="right">
                    Load More Reviews
                  </Button>
                </div>
              </> :

            <GalleryGrid images={galleryImages} category={activeCategory} />
            }
          </div>
        </section>

        <section className="py-16 bg-muted/30">
          <div className="container-custom">
            <InstagramFeed posts={instagramPosts} />
          </div>
        </section>

        <section className="py-16">
          <div className="container-custom">
            <MediaMentions mentions={mediaMentions} />
          </div>
        </section>

        <section className="py-16 bg-gradient-to-br from-primary/5 to-accent/5">
          <div className="container-custom">
            <div className="max-w-4xl mx-auto text-center">
              <Icon name="Heart" size={48} color="var(--color-primary)" className="mx-auto mb-6" />
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-foreground mb-4">
                Share Your Montesanto Experience
              </h2>
              <p className="text-lg text-muted-foreground mb-8">
                Your feedback helps us continue bringing authentic Italian joy to our community. Share your story and inspire others to discover the warmth of Montesanto.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Button
                  variant="default"
                  size="lg"
                  iconName="Star"
                  iconPosition="left"
                  onClick={() => setIsModalOpen(true)}>

                  Write Your Review
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  iconName="Camera"
                  iconPosition="left">

                  Share Your Photos
                </Button>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <SubmitReviewModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </div>);

};

export default GalleryReviews;